import auditService from "../services/auditService";

export const GET_CATEGORY_WISE_EXCEL_REPORT = "GET_CATEGORY_WISE_EXCEL_REPORT";
export const GET_CATEGORY_WISE_EXCEL_REPORT_SUCCESS =
  "GET_CATEGORY_WISE_EXCEL_REPORT_SUCCESS";
export const GET_CATEGORY_WISE_EXCEL_REPORT_ERROR =
  "GET_CATEGORY_WISE_EXCEL_REPORT_ERROR";

  // Category Wise Excel Report start
  export function getCategoryWiseExcelReportRecord(query) {
    return async (dispatch) => {
      dispatch(getCategoryWiseExcelReport());
      return await auditService
        .getCategoryWiseExcelReport(query)
  
        .then((response) =>
          dispatch(getCategoryWiseExcelReportSuccess(response)),
        )
        .catch((error) => dispatch(getCategoryWiseExcelReportError(error)));
    };
  }
  
  export function getCategoryWiseExcelReport() {
    return {
      type: GET_CATEGORY_WISE_EXCEL_REPORT,
    };
  }
  
  export function getCategoryWiseExcelReportSuccess(success) {
    return {
      type: GET_CATEGORY_WISE_EXCEL_REPORT_SUCCESS,
      payload: { success },
    };
  }
  
  export function getCategoryWiseExcelReportError(error) {
    return {
      type: GET_CATEGORY_WISE_EXCEL_REPORT_ERROR,
      payload: { error },
    };
  }
  
  // Category Wise Excel Report End